import { useContext, useEffect, useState } from 'react';
import { createAppError } from 'utils/helpers';
import { AppContext, IAppContext } from 'appState/appContext';

interface IAnyObject {
	[key: string]: any;
}

export const useCompareFormData = (initialFormData: IAnyObject | null, currentFormData: IAnyObject): boolean => {
	const { addAppError } = useContext<IAppContext>(AppContext);
	const [isEqual, setIsEqual] = useState(true);

	const sortFormDataByKeys = (formData: IAnyObject): string => {
		const orderedFormData = Object.keys(formData)
			.sort()
			.reduce((obj: IAnyObject, key) => {
				obj[key] = formData[key];
				return obj;
			}, {});

		return JSON.stringify(orderedFormData);
	};

	useEffect(() => {
		if (initialFormData) {
			try {
				setIsEqual(sortFormDataByKeys(initialFormData) === sortFormDataByKeys(currentFormData));
			} catch (err) {
				const error = err as Error;
				const appError = createAppError(error);
				addAppError(appError);
			}
		}
	}, [initialFormData, currentFormData]);

	return isEqual;
};
